module.exports = __webpack_public_path__ + "static/media/aWoman.4426dd38.png";